The list of profiles associated with with the candidate.

Uploaded candidates sourced from the `uploadCandidate` mutation have a single profile.

SEEK candidates have a profile per submitted application.
This field exposes up to 10 recent applications submitted by the candidate.

We recommend querying specific applications by their `CandidateProfile.profileId`s for the Optimised Apply use case.

This field is redacted and an empty/filtered list is returned when a candidate or job application is deleted.
